
namespace RioERP.Products {
    export class ProductPendrivesColumns {
        static columnsKey = 'Products.ProductPendrives';
    }
}